export default __webpack_public_path__ + "static/media/bookshelvesMobileView.10efa7d5.png";